import moment from "moment";

/**
 * Display helpers shared by the Holds page and its modals. Kept framework-free so
 * the table template and the modal templates format values identically.
 */

/** Amount with thousands separators and exactly two decimals. Currency stays a raw code. */
export function formatAmount(value) {
  const n = Number(value);
  if (value === null || value === undefined || value === "" || Number.isNaN(n)) {
    return "—";
  }
  return n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/** Consistent UTC `DD-MM-YYYY HH:mm:ss`, matching the Transaction List. */
export function formatUtcDateTime(value) {
  if (!value) return "—";
  const m = moment.utc(value);
  return m.isValid() ? m.format("DD-MM-YYYY HH:mm:ss") : "—";
}

/** First 8 chars of a UUID with an ellipsis, for the truncated id columns. */
export function truncateId(id) {
  if (!id || typeof id !== "string") return "—";
  return id.length > 8 ? `${id.slice(0, 8)}…` : id;
}
